export default __webpack_public_path__ + "static/media/logo-white.6a2b2982.svg";